import { render, staticRenderFns } from "./GetOriginal.vue?vue&type=template&id=1304c466&scoped=true&"
import script from "./GetOriginal.vue?vue&type=script&lang=js&"
export * from "./GetOriginal.vue?vue&type=script&lang=js&"
import style0 from "./GetOriginal.vue?vue&type=style&index=0&id=1304c466&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304c466",
  null
  
)

export default component.exports